import { useContext } from 'react';
import { InjectorContext } from "../context/index.js";
/**
 * Custom hook that returns an Injecor instance from the InjectorContext.
 */
export const useInjector = () => useContext(InjectorContext);
//# sourceMappingURL=use-injector.js.map